import * as types from '../actions/types';

const initialState = {
  progress: [],
  progressDetail: [],
  terms: [],
  rateExam: [],
  course: []
};

export default function performance(state = initialState, action) {
  switch (action.type) {
    case types.PERFORMANCE_LIST_FETCH_STARTED:
      return {
        ...state,
      };
    case types.PERFORMANCE_LIST_FETCH_COMPLETED:
      return {
        ...state,
        progress: action.payload,
      };
    case types.PERFORMANCE_FETCH_STARTED:
      return {
        ...state,
      };
    case types.PERFORMANCE_FETCH_COMPLETED:
      return {
        ...state,
        progressDetail: action.progressDetail,
      };
    case types.TERMS_FETCH_COMPLETED:
      return {
        ...state,
        terms: action.terms,
      };
    case types.COURSE_FETCH_COMPLETED:
      return {
        ...state,
        course: action.course,
      };
    case types.MARK_LIST:
      return {
        ...state,
        rateExam: action.payload,
      };
    default:
      return state;
  }
}
